import { Injectable } from '@angular/core';
import html2canvas, { Options } from 'html2canvas';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HTML2CanvasService {
  public html2Canvas(element: HTMLElement, options?: Partial<Options>): Observable<HTMLCanvasElement> {
    return from(html2canvas(element, options));
  }
}
